import { render } from "./dialogEx.vue?vue&type=template&id=b820e378&scoped=true"
import script from "./dialogEx.vue?vue&type=script&lang=js"
export * from "./dialogEx.vue?vue&type=script&lang=js"

import "./dialogEx.vue?vue&type=style&index=0&id=b820e378&scoped=true&lang=css"

import exportComponent from "E:\\Work\\GPTWeb\\licCode\\lic\\webviewer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b820e378"]])

export default __exports__